import React, { Component } from 'react';
import { ThemeContext } from '../../../Themes/ThemeContext';
import IconButton from '../Buttons/IconButton/IconButton';
import HeaderButtons from './HeaderButtons';
import { T } from '../Response/Utils';
import { truthyOrFalsy } from '../../../Utils/Contexts';
import Refresh from '../../../../assets/imgs/refresh.png';
import Back from '../../../../assets/imgs/Back.png';
interface Props {
	botName: string;
	toggleOverlay;
	toggleChatBody;
	isUserLoggedin;
	triggerLogout;
	isChatBodyVisible;
	hideBot;
	data;
	handleModalToggle?;
	theme?;
	redirectToExternalBot;
	toShowRedDot;
	isOverlayVisible: boolean;
	toggleLang;
	isModalVisible;
	headerExternalTheme?: boolean;
	feedbackDone;
	restartFlow;
	toLang;
	mandatoryCollection;
	detailCollection;
	sessionComplete;
	isConnectedToNetwork;
	disableRefresh;
	isChatStarted: boolean;
	flyFishChangesReq: boolean;
	isInsideKampsta: boolean;
	channel: string;
	showWelcomeScreen: boolean;
	RefreshSession: Function;
	HideWelcomeScreen: Function;
	currentScreen: string;
	changeScreen: Function;
}

const styleVars = getComputedStyle(document.querySelector(':root'));

interface State {
	backTooltip;
}
class Header extends Component<Props, State> {
	constructor(props) {
		super(props);
		this['contextTheme'] = props['context'];
		this.state = {
			backTooltip: '',
		};
	}
	checkIfExternalLinkRequired() {
		const url = window.location.pathname;
		if (
			url === '/chatsdk.html' &&
			window.location.origin !=
				'http://ec2-13-233-208-207.ap-south-1.compute.amazonaws.com' && //NOSONAR
			window.location.origin != 'https://aware.senseforth.com' &&
			window.location.origin != 'http://aware.senseforth.com' //NOSONAR
		) {
			return false;
		}
		return true;
	}

	isURLAbsolute(url) {
		return url.includes('http');
	}

	getBackTooltip = (data?: any) => {
		this.setState({
			backTooltip: data,
		});
	};
	render() {
		let foreground = styleVars.getPropertyValue('--headerColor');

		return (
			<div
				className={`sf-header-app-external ${
					this.props.channel === 'whatsapp' ? 'sf-header-whatsapp' : ''
				} ${
					this.props.data.isInsideCampaign && !this.props.isOverlayVisible
						? this.props.data.notification === 'true' ||
						  this.props.data.isMultiLingualEnabled === 'true' ||
						  this.props.isUserLoggedin
							? 'center-header'
							: 'only-header'
						: this.props.headerExternalTheme
						? 'non-camp-only-header'
						: ''
				} 
        ${this.props.isOverlayVisible ? 'notification-header' : ''}
        ${this.props.isConnectedToNetwork ? '' : 'no-shadow-header'}
		
        `}
				style={
					this.props.showWelcomeScreen
						? {
								// backgroundImage: `url(${headerGradient})`,
								// backgroundSize: "100% 100%",
								background: '#2B8DED',
								backgroundRepeat: 'no-repeat',
								boxShadow: 'unset',
								backgroundColor: 'unset',
						  }
						: {}
				}
			>
				{this.props.showWelcomeScreen ? (
					<div className={`header-title-wrapper `}>
						<div className='torso header-torso'>
							<img
								className='header-image'
								style={{
									objectPosition:
										this.props.headerExternalTheme ||
										this.props.data.isInsideCampaign
											? 'center'
											: 'left',
								}}
								src={
									this.props.data.flyFishChangesReq === true
										? this.props.data.headerImage
										: this.isURLAbsolute(this.props.data.headerImage)
										? this.props.data.headerImage
										: window['BASE_URL']
										? window['BASE_URL'] + this.props.data.headerImage
										: this.props.data.headerImage
								}
								alt={this.props.botName}
							/>
						</div>
					</div>
				) : (
					<div className={`header-title-wrapper-app-external `}>
						{/* <img
							className='back-icon'
							style={{
								objectPosition:
									this.props.headerExternalTheme ||
									this.props.data.isInsideCampaign
										? 'center'
										: 'left',
								height: '21px',
								width: '13px',
								cursor: 'pointer',
							}}
							src={Back}
							onClick={() => {
								this.props.HideWelcomeScreen(true);
							}}
							alt={'Back'}
						/> */}

						{this.props.channel === 'whatsapp' && (
							<div className='whatsapp-name-icon'>
								{this.props.botName[0].toUpperCase()}
							</div>
						)}
						{this.props.isOverlayVisible ? (
							<div
								className={`header-title ${
									this.props.data.isInsideCampaign
										? 'head-text-2'
										: 'body-text-1'
								}`}
							>
								<IconButton
									variant={'empty'}
									size={'normal'}
									onClick={() => {
										this.props.toggleOverlay();
									}}
									fill={foreground}
									image={'back'}
									title={this.state.backTooltip}
								/>
								<T labelName='notificationsLabel' />
							</div>
						) : this.props.data.headerContentType &&
						  this.props.data.headerContentType === 'image' ? (
							<div className='torso header-torso'>
								<img
									className='header-image'
									style={{
										objectPosition:
											this.props.headerExternalTheme ||
											this.props.data.isInsideCampaign
												? 'center'
												: 'left',
									}}
									src={
										this.props.data.flyFishChangesReq === true
											? this.props.data.headerImage
											: this.isURLAbsolute(this.props.data.headerImage)
											? this.props.data.headerImage
											: window['BASE_URL']
											? window['BASE_URL'] + this.props.data.headerImage
											: this.props.data.headerImage
									}
									alt={
										this.props.data.botNameAsTitle === 'false'
											? this.props.data.headerTitle
											: this.props.botName
									}
								/>
							</div>
						) : (
							<div
								className={`header-title-app-external ${
									this.props.data.isInsideCampaign ||
									this.props.headerExternalTheme
										? 'head-text-2'
										: 'body-text-1'
								}`}
								title={
									truthyOrFalsy(this.props.data.botNameAsTitle)
										? this.props.botName
										: this.props.data.headerTitle
										? this.props.data.headerTitle
										: this.props.botName
								}
								style={{
									color:
										this.props.data.colorMode === 'dark'
											? '#fff'
											: this.props.data.colorScale[0],
								}}
							>
								{this.props.currentScreen !== 'homescreen' && this.props.currentScreen !== 'getintouchscreen' ? (
									<svg
										onClick={() => {
											this.props.changeScreen('homescreen');
										}}
										style={{ cursor: 'pointer',marginRight:"8px" }}
										xmlns='http://www.w3.org/2000/svg'
										width='24'
										height='24'
										viewBox='0 0 24 24'
									>
										<path
											data-name='Path 15579'
											d='M0 0h24v24H0z'
											fill='none'
										/>
										<path
											data-name='Path 15580'
											d='M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z'
											fill={
												this.props.data.colorMode === 'dark'
													? '#fff'
													: this.props.data.colorScale[0]
											}
										/>
									</svg>
								) : null}
								<p style={{ fontWeight: '600' }}>
									{truthyOrFalsy(this.props.data.botNameAsTitle)
										? this.props.botName
										: this.props.data.headerTitle
										? this.props.data.headerTitle
										: this.props.botName}
								</p>
							</div>
						)}
						{/* <img
							className='refresh-icon'
							style={{
								objectPosition:
									this.props.headerExternalTheme ||
									this.props.data.isInsideCampaign
										? 'center'
										: 'left',
								height: '23px',
								width: '21px',
								cursor: 'pointer',
							}}
							src={Refresh}
							onClick={() => {
								this.props.RefreshSession();
								
							}}
							alt={'Refresh'}
						/> */}
						<svg
							style={{ cursor: 'pointer' }}
							onClick={() => {
								this.props.hideBot();
							}}
							xmlns='http://www.w3.org/2000/svg'
							width='24'
							height='24'
							viewBox='0 0 24 24'
						>
							<path data-name='Rectangle 17142' fill='none' d='M0 0h24v24H0z' />
							<path
								data-name='Path 23'
								d='M22 3.41 16.71 8.7 20 12h-8V4l3.29 3.29L20.59 2zM3.41 22l5.29-5.29L12 20v-8H4l3.29 3.29L2 20.59z'
								fill={
									this.props.data.colorMode === 'dark'
										? '#fff'
										: this.props.data.colorScale[0]
								}
							/>
						</svg>
					</div>
				)}
				<HeaderButtons
					{...this.props}
					foreground={foreground}
					onSelect={this.getBackTooltip}
				/>
			</div>
		);
	}
}

Header['contextType'] = ThemeContext;

export default (props) => (
	<ThemeContext.Consumer>
		{(context) => <Header {...props} context={context} />}
	</ThemeContext.Consumer>
);
